import React, { useState } from "react";
import { Modal, Form, Input, Button, Row } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { AuthService } from "../Services/AuthService";

interface ChangePasswordModalProps {
  open: boolean;
  onClose: () => void;
  userId: string | number | undefined;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ open, onClose, userId }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const res = await AuthService.changePassword(
        String(userId),
        values.currentPassword,
        values.newPassword,
        values.confirmPassword
      );
      if (res) {
        onClose();
        form.resetFields();
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
    form.resetFields();
  };

  return (
    <Modal
      destroyOnClose
      title="Change password"
      width={400}
      open={open}
      onCancel={handleCancel}
      onOk={() => {}}
      footer={
        <Button type="primary" size="middle" loading={loading} onClick={handleSubmit}>
          <SaveOutlined /> Submit
        </Button>
      }
    >
      <Form
        form={form}
        name="change-password"
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
        autoComplete="off"
        colon={false}
        size="small"
      >
        <Row className="border-bottom" style={{ marginBottom: 18 }} />
        <Form.Item
          label="Current password"
          name="currentPassword"
          labelAlign="left"
          className="form-item-input"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Input.Password className="borderLessInput w100" />
        </Form.Item>
        <Form.Item
          label="New password"
          name="newPassword"
          labelAlign="left"
          className="form-item-input"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Input.Password className="borderLessInput w100" />
        </Form.Item>
        <Form.Item
          label="Confirm password"
          name="confirmPassword"
          labelAlign="left"
          className="form-item-input"
          rules={[
            { required: true, message: "This field is required" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) return Promise.resolve();
                return Promise.reject(new Error("Passwords do not match!"));
              },
            }),
          ]}
        >
          <Input.Password className="borderLessInput w100" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
